import { Component, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject, interval, takeUntil } from 'rxjs';
import { GoogleSpeechService, JkBaseComponent } from 'jk-service';
import { MatIconModule } from '@angular/material/icon';
import { MatLabel } from '@angular/material/form-field';
import { JkcheckboxComponent } from 'jk-service';
import { AzureTtsService } from 'jk-service';
import { webSpeechClass } from 'jk-service';
import { AudioService, mp3_pristine } from 'jk-service';
import { CR, AzureEnvironment } from 'jk-service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
//import { NgxGaugeModule } from 'ngx-gauge';
//import { GaugeModule } from 'ng2-gauge';

@Component({
  selector: 'app-tea-timer',
  templateUrl: './tea-timer.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule, MatLabel, JkcheckboxComponent], // GaugeModule
})
export class TeaTimerComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'tea-timer';
  @Input() googleApiKey: string = '';
  // 注入 dialog data
  private dialogData = inject(MAT_DIALOG_DATA, { optional: true });  //@Input() azureEnv!:AzureEnvironment;

  //azureEnv!:AzureEnvironment;
  //tts: AzureTtsService = inject(AzureTtsService);
  waitSecond: number = 60;
  second: number = 0;
  buttonDisabled: boolean = false;
  stop$: any;
  webSpeech: webSpeechClass;
  voiceIndex: number = 21;
  isAzureSpeech: boolean = true;
  //az: jkAzureClass  = new jkAzureClass();
  constructor(public tts: GoogleSpeechService) {
    super();
    this.webSpeech = new webSpeechClass(this.cdr);
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override ngAfterViewInit() {
    super.ngAfterViewInit();

    this.voiceIndex = this.webSpeech.language2VoiceIndex('zh-TW');// prompt("Please enter a string:");
    //alert('tea-timer voiceIndex='+this.voiceIndex);
    const apiKey = this.dialogData?.googleApiKey ?? this.googleApiKey;
    this.tts.setApiKey(apiKey);
  }

  startTimer(sec: number) {
    this.waitSecond = sec;
    this.buttonDisabled = true;
    let msg = '計時' + sec + '秒';
    //this.tts.speakText(this.azureEnv,msg);
    this.tts.textToSpeech(msg).subscribe({
      next: (result) => this.playAudio(result),
      error: (err) => console.error('Error during TTS:', err)
    });


    const audio = new AudioService();// 'pristine.mp3'
    audio.play(mp3_pristine);

    this.stop$ = new Subject();
    const countdown$ = interval(1000).pipe(takeUntil(this.stop$));

    countdown$.subscribe((count) => {
      this.second = sec - count;
      //console.log(`Remaining seconds: ${remainingSeconds}`);
      if (this.second < 3) {
        this.tts.textToSpeech(this.second.toString()).subscribe({
          next: (result) => this.playAudio(result),
          error: (err) => console.error('Error during TTS:', err)
        });
        const audio = new AudioService();
        audio.play(mp3_pristine);
      }

      if (this.second === 0) {
        //console.log('Countdown finished!');
        this.stop$.next(0);
        this.stop$.complete();
        this.buttonDisabled = false;
      }
      this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
    });
  }
  resetTimer() {
    //this.waitSecond = 0;
    this.second = 0;
    this.buttonDisabled = false;
    //this.countDown$.complete();
    //this.countDown$.unsubscribe();
    // 中斷計時
    this.stop$.next();
    this.stop$.complete();
    let message = '時間歸零';
    //this.tts.speakText(this.azureEnv,message);
    this.tts.textToSpeech(message).subscribe({
      next: (result) => this.playAudio(result),
      error: (err) => console.error('Error during TTS:', err)
    });

  }
  async showVoices() {
    //let n = this.webSpeech.language2VoiceIndex('zh-TW'); // prompt("Please enter a string:");
    let msg = '第' + this.voiceIndex + '語言' + CR + this.webSpeech.getSettings();
    alert(msg);
  }
}
